import PropTypes from "prop-types";

import AdminConsoleFacultyAdderTeacherSection from "../AdminConsoleFacultyAdderTeacherSection";

const propTypes = {
  // Component form values.
  formValues: PropTypes.shape({
    lowestGrade: PropTypes.shape({
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
          key: PropTypes.number,
          description: PropTypes.string,
        }),
      ]),
      touched: PropTypes.bool,
      errorMessage: PropTypes.string,
    }),
    highestGrade: PropTypes.shape({
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
          key: PropTypes.number,
          description: PropTypes.string,
        }),
      ]),
      touched: PropTypes.bool,
      errorMessage: PropTypes.string,
    }),
    sisId: PropTypes.string,
    school: PropTypes.shape({
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
          id: PropTypes.number,
          name: PropTypes.string,
          uniqueId: PropTypes.string,
        }),
      ]),
      touched: PropTypes.bool,
      errorMessage: PropTypes.string,
    }),
    isTeacher: PropTypes.bool,
    subjects: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        checked: PropTypes.bool,
      }),
    ),
  }),
  // Parent reducer dispatcher.
  dispatchAction: PropTypes.func,
};

const AdminConsoleFacultyAdderSchoolAdminSection = ({
  formValues,
  dispatchAction,
}) => {
  /** At least for now, school admin section is the same as the teacher section.
   * Nevertheless We implement the component in case this changes in the future.
   **/
  return (
    <AdminConsoleFacultyAdderTeacherSection
      formValues={formValues}
      dispatchAction={dispatchAction}
    />
  );
};

AdminConsoleFacultyAdderSchoolAdminSection.propTypes = propTypes;

export default AdminConsoleFacultyAdderSchoolAdminSection;
